import {
  PartnerBindingEditorDictionary,
  TClientDetailsIntl,
  ClientDetailsProductsScreenDictionary,
  ClientProductEditorDictionary,
  TClientDetailsRefundEditorIntl,
} from 'types/i18n';
import { PartnerProfile } from 'types/state';
import { normalizeProfileLike } from 'utils/profileLikeUtils';
import { sharedDictionaryRu } from './sharedDictionaryRu';

const table = {
  clientInfoTitle: 'О клиенте',
  stackInfoTitle: 'Приложение',
  planInfoTitle: 'Подписка',
  transactionsInfoTitle: 'Списания и платежи',
  paymentsTitle: 'Платежи',
  partnerBindingTitle: 'Клиента пригласил партнер',

  trialDueLabel: 'Триал до',
  licenseDueLabel: 'Лицензия до',
  demoLabel: 'Демо',
  fullNameLabel: 'ФИО',
  positionLabel: 'Должность',
  staffLabel: 'Штат',
  phoneLabel: 'Телефон',
  emailLabel: 'Email',
  dnsLabel: 'Доменное имя',
  registeredOnLabel: 'Регистрация',
  updatedOnLabel: 'Изменение',
  locationLabel: 'Страна',
  idLabel: 'id',
  stackURLLabel: 'Адрес',
  stackSubdomainLabel: 'Доменное имя',
  managersCountLabel: 'Пользователей',
  stackUpdatedAtLabel: 'Обновление',
  balanceLabel: 'Баланс',
  unpLabel: 'УНП (ИНН / TIN)',
  orgNameLabel: 'Организация',
  orgAdressLabel: 'Адрес',
  requesitesTitle: 'Реквизиты организации',
  nextPaymentDateLabel: 'Оплата',
  residentLabel: 'Резидент РБ',
  partnerFullNameLabel: 'ФИО',
  partnerCodeLabel: 'Код партнера',
  clientIncomeLabel: 'Доход c клиента',
  partnerPartLabel: 'Доля партнера',
  agmPartLabel: 'Доля AGM',

  transactionsFallbackValue: 'Нет списаний и платежей',
  nextPaymentDateFallbackValue: 'Не укaзана',
  managersCountFailedValue: 'Ошибка',

  paymentAmountValue: (amount: number) =>
    `+ ${sharedDictionaryRu.moneyAmountText(amount, 'USD')}`,
  invoiceAmountValue: (amount: number) =>
    `- ${sharedDictionaryRu.moneyAmountText(amount, 'USD')}`,
  invoiceNumberValue: (number: number) => `Счет №${number}`,
  residentValue(resident: null | boolean) {
    if (resident) {
      return 'Да';
    }

    return 'Нет';
  },
  partnerFullNameValue(partnerProfile: PartnerProfile) {
    return normalizeProfileLike(partnerProfile).toFullName();
  },
};

const tabs = {
  paymentsTabLabel: 'Списания и платежи',
  productsTabLabel: 'Продукты',
  summaryTabLabel: 'Сводка',
};

const buttons = {
  moveToArchive: 'В архив',
  removeFromArchive: 'Восстановить из архива',
  createBonus: 'Начислить бонус',
  createInvoice: 'Выставить счет',
  createStack: 'Создать приложение',
  editProfile: 'Редактировать анкету',
  editLogin: 'Редактировать логин',
  editPassword: 'Редактировать пароль',
  editPartnerBinding: 'Редактировать партнера',
  deletePartnerBinding: 'Удалить привязку',
  createRefund: 'Возврат средств',
};

const profileEditor = {
  title: 'Редактирование анкеты',
};

const loginEditor = {
  title: 'Редактирование логина',
};

const passwordEditor = {
  title: 'Редактирование пароля',
};

const partnerBindingEditor: PartnerBindingEditorDictionary = {
  title: 'Привязка партнера',
  partnerCodeLabel: 'Код партнера',
  fullNameLabel: 'ФИО партнера',
  partnerNotFoundFallback: 'Партнер не найден',
};

const productsScreen: ClientDetailsProductsScreenDictionary = {
  productDescriptionLabel: 'Название',
  agmPartLabel: 'Доля AGM',
  partnerPartLabel: 'Доля партнера',
  discountPartLabel: 'Скидка',
  tariffLabel: 'Тариф для клиента',
  editProductActionText: 'Редактировать продукт',
  percentValue(percent) {
    return `${percent}%`;
  },
  amountValue(amount) {
    return sharedDictionaryRu.moneyAmountText(amount, 'USD');
  },
  tariffPercentValue(percent) {
    return `(-${percent}%)`;
  },
  tariffAmountValue(amount) {
    return sharedDictionaryRu.moneyAmountText(amount, 'USD');
  },
};

const productEditor: ClientProductEditorDictionary = {
  title: 'Редактирование продукта',
  agmRowLabel: 'Доля AGM',
  agmRowValue(agmPercent) {
    return `${agmPercent}`;
  },
  agmRowResult(agmAmount) {
    return sharedDictionaryRu.moneyAmountText(agmAmount, 'USD');
  },
  clientRowLabel: 'Скидка',
  clientRowValue(clientPercent) {
    return `${clientPercent}`;
  },
  clientRowResult(clientAmount) {
    return sharedDictionaryRu.moneyAmountText(clientAmount, 'USD');
  },
  partnerRowLabel: 'Доля партнера',
  partnerRowValue(partnerPercent) {
    return `${partnerPercent}`;
  },
  partnerRowResult(partnerAmount) {
    return sharedDictionaryRu.moneyAmountText(partnerAmount, 'USD');
  },
  tariffRowLabel: 'Тариф для клиента',
  tariffRowValue(tariffAmount) {
    return sharedDictionaryRu.moneyAmountText(tariffAmount, 'USD');
  },
  tariffRowResult(tariffPercent) {
    return `(-${tariffPercent}%)`;
  },
  progressValue(percent) {
    return `${percent}%`;
  },
};

const refundEditor: TClientDetailsRefundEditorIntl = {
  titleText: 'Возврат денежных средств',
  defaultCommentText: 'Возврат денежных средств',
  submitButtonText: 'Списать деньги с баланса',
};

export const clientDetailsIntl: TClientDetailsIntl = {
  tabs,
  buttons,
  table,
  profileEditor,
  refundEditor,
  loginEditor,
  passwordEditor,
  partnerBindingEditor,
  productsScreen,
  productEditor,
};
